import axios from '../config/axios';

const GET_QRT_CLIENT = 'api/QuestionnaireClient/AfficherQuestionnaireClient';
const POST_RPS_QRT = 'api/QuestionnaireClient/EnregisterReponse';

export const getQrtClient = (tkn) => {
    return axios.get(GET_QRT_CLIENT, {
        params: {
            tkn: tkn,
        }
    });
};

export const postRpsQrt = (data) => {
    return axios.post(POST_RPS_QRT, data);
};

